import { ProductListSortFragment, useProductListParamsContext } from "@graphcommerce/magento-product"
import Link from "next/link"
import { useRouter } from "next/router"
import { createProductListLink } from "../../ProductList/ProductListLimit"

const sortItems = [
  'بیشترین تخفیف',
  'قیمت از کم به زیاد',
  'قیمت از زیاد به کم',
  'پربازدیدترین',
  'محبوب‌ترین',
  'پرفروش‌ترین',
]

export type ProductListSortProps = ProductListSortFragment
export default function ProductSortLayout({ sort_fields }: ProductListSortProps) {
  const { params } = useProductListParamsContext()



  const router = useRouter()

  function toProductListParams(params: any): any {
    const { sort, ...rest } = params
    return { sort, ...rest }
  }
  const push = (params: any) => {
    const queryUrl = router.query.url ?? []
    const comingFromURLWithoutFilters = !queryUrl.includes('q')

    const path = createProductListLink({ ...params })

    if (router.asPath === path) return false

    // push the first filter, so the new route (on browser back) will be e.g. /women/fruit instead of /women
    if (comingFromURLWithoutFilters)
      return router.push(path, path)


    router.replace(path, path)
  }

  return (<div className="fixed hidden z-10 992:z-[-1] 992:hidden items-center justify-center right-0 left-0 top-0 bottom-0 opacity-0" id="ProductSortLayout">
    <div className="bg-[#00000020] hidden opacity-0 992:hidden 992:opacity-0 fixed right-0 left-0 top-0 bottom-0" id="ProductSortLayoutBack" />
    <div className="bg-white rounded-md overflow-hidden p-2 w-[90%] max-w-sm  -top-[100px] relative opacity-0 -translate-y-20 transition-all" id="ProductSortList">
      <p className="text-base text-black font-medium">به ترتیب</p>
      <ul>
        {sort_fields && sort_fields?.options?.map((item, index) => (
          <li key={index} className={`border py-3 text-center border-solid border-light-100 border-x-0 border-t-0 ${index === sortItems.length - 1 && 'border-b-0'}`}>
            <Link
              href="javascript:void(0)"
              onClick={(e) => {
                e.stopPropagation();
                if (item?.value) {
                  push({
                    ...toProductListParams({
                      ...params, sort: {
                        [item.value]: 'ASC'
                      }
                    }),
                    currentPage: 1
                  })
                }
              }
              }
              className="w-full text-center  text-default-900 text-sm hover:text-primary-500">
              {item?.label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  </div>

  )
}